import axios from './axiosInstance';

export default class CategoriaLegislacaoApi {
    static async getCategorias() {
        return axios.get(`${process.env.VUE_APP_BASE_API_URL}/api/v1/categorias_legislacao_selecionada`);
    }
}